import { render, staticRenderFns } from "./sensorDevice.vue?vue&type=template&id=61d53b75&scoped=true"
import script from "./sensorDevice.vue?vue&type=script&lang=js"
export * from "./sensorDevice.vue?vue&type=script&lang=js"
import style0 from "./sensorDevice.vue?vue&type=style&index=0&id=61d53b75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d53b75",
  null
  
)

export default component.exports